import { useCore } from "@spectral-finance/react-core";
import React from "react";
import SpectralLogo from "../../../../assets/spectral.svg";
import { useSpectral } from "../../../../contexts/SpectralContext";
import useMediaQuery from "../../../../hooks/useMediaQuery";
import { AddMoreWallets } from "../../../AddMoreWallets";
import Flex from "../../../Flex";
import ScoreGauge from "../../../ScoreGauge";
import { SpectralButton } from "../../../SpectralButton";
import { Tooltip } from "../../../Tooltip";
import * as SC from "./Success.styles";

export const Success = () => {
  const isMobile = useMediaQuery("(max-width: 600px)");
  const { score, account } = useCore();
  const { close } = useSpectral();

  const MacroScoreTooltipContent = () => {
    return (
      <SC.MacroScoreTooltipContainer>
        <h3>What is a MACRO score?</h3>
        <span>
          Your Multi Asset Credit Risk Oracle is your onchain score.
          <br />
          <br />
          We assess this based on 7 different sections.
          <br />
          <br />
          If you want to know more about the dimensions of your score you can go
          visit{" "}
          <a href="https://spectral.finaance" target="_blank">
            spectral.finance
          </a>
          .
        </span>
        <br />
      </SC.MacroScoreTooltipContainer>
    );
  };

  return (
    <Flex
      width="100%"
      height="100%"
      column
      align="center"
      justify={isMobile ? "flex-start" : "center"}
    >
      <img src={SpectralLogo} alt="Spectral Logo" />
      <h1>Done!</h1>
      <SC.SuccessDescription>
        <Tooltip content={<MacroScoreTooltipContent />}>
          <a href="https://spectral.finance" target="_blank">
            Your
            <label> MACRO score </label>
            has been successfuly generated and shared with the lender.
          </a>
        </Tooltip>
      </SC.SuccessDescription>

      <ScoreGauge score={score.score} updatedAt={score.scoreTimestamp} />

      {!account.minted && <AddMoreWallets />}

      <SC.BundleButtonWrapper width="100%">
        <SpectralButton
          label="Close"
          width="100%"
          height="56px"
          onClick={close}
        />
      </SC.BundleButtonWrapper>
    </Flex>
  );
};
